import { Button, Card, Grid, Group, Stack, Title } from '@mantine/core';
import { ActiveSubscriptions } from './ActiveSubscriptions';
import { InactiveSubscriptions } from './InactiveSubscriptions';
import { useNavigate } from 'react-router-dom';
import { AppStats } from './AppStats';
// import { ManualsButton } from './ManualsButton';

export function AppSection() {
  const navigate = useNavigate();

  return (
    <Stack gap='xs'>
      <Card shadow='sm' withBorder radius='sm'>
        <Group justify='space-between'>
          <Title order={3}>App</Title>
          <Button onClick={() => navigate('/sessions')}>
            Esplora tutte le app
          </Button>
        </Group>
      </Card>
      <Grid gutter='xs'>
        <Grid.Col span={{ base: 12, md: 6, xl: 12 }}>
          <ActiveSubscriptions />
        </Grid.Col>

        <Grid.Col span={{ base: 12, md: 6, xl: 12 }}>
          <InactiveSubscriptions />
        </Grid.Col>
      </Grid>
      <AppStats />

      {/*
      <ManualsButton /> */}
    </Stack>
  );
}
